module.exports = __webpack_public_path__ + "static/img/SFC-logo.9a3cc38.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/menu/img/SFC-logo.png
// module id = QEYX
// module chunks = 1